import React from "react"

const Logo = ({ fadeIn }: { fadeIn?: boolean }) => {
    return (
        <svg
            className={fadeIn ? "fadeIn" : ""}
            width="50%"
            height="50%"
            viewBox="0 0 500 500"
            version="1.1"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeLinecap: "round",
                strokeMiterlimit: 2,
            }}
        >
            <g id="Layer1">
                <g transform="matrix(1.36401,0,0,1.36401,-80.2978,-101.639)">
                    <circle
                        cx="242.152"
                        cy="257.798"
                        r="175.952"
                        style={{
                            fill: "rgb(6, 37, 57)",
                            stroke: "rgb(6, 37, 57)",
                            strokeWidth: "0.73px",
                        }}
                    />
                </g>
                <path
                    className="logo-path1"
                    d="M141.889,319.788L329.055,252.233L250.099,94.039L111.253,369.045L345.203,284.835L388.263,368.725L188.926,296.541L247.091,179.607"
                    style={{ fill: "none", stroke: "white", strokeWidth: "18.75px" }}
                />
                <path
                    className="logo-path2"
                    d="M231.291,136.791L338.019,348.438"
                    style={{
                        fill: "none",
                        stroke: "white",
                        strokeWidth: "16.67px",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 1.5,
                    }}
                />
                <g transform="matrix(1.07024,-0.0250634,-0.0250634,1.00894,-18.4041,6.56719)">
                    <path
                        d="M355.611,262.274L160.332,332.091"
                        style={{
                            fill: "none",
                            stroke: "rgb(6,37,57)",
                            strokeWidth: "17.65px",
                            strokeLinecap: "butt",
                        }}
                    />
                </g>
            </g>
        </svg>
    )
}

export default Logo
